// extracted by mini-css-extract-plugin
export var accordionContent = "accordion-module--accordion-content--0lJF0";
export var active = "accordion-module--active--rVcE+ accordion-module--common--M8O1o";
export var common = "accordion-module--common--M8O1o";
export var inactive = "accordion-module--inactive--+Poo+ accordion-module--common--M8O1o";